/*eslint no-console: 0, new-cap: 0*/
(function($){
    // Match this with the breakpoint at which the screen transforms
    // from smaller size to medium size
    var minMq        = '(min-width: 60em)';
    var $body        = $('body');
    var $nav         = $('#navbar__dropdown');
    var $itemCurrent = $('.navbar__item--current');

    // Toggling mobile menu
    $('.navbar__toggle, .navbar__overlay').click(function() {
        mobileNavToggle();
    });

    // Load the menu
    function loadMenu() {
        var isCurrent = $nav.find('.navbar__item--current .navbar__sub-nav').length !== 0;
        $nav.NavBar({
            onState: function($item, active) {
                if (isCurrent) {
                    return;
                }
                if ($item.find('.navbar__sub-nav').length && active) {
                    $body.addClass('is-nav-active');
                } else {
                    $body.removeClass('is-nav-active');
                }
            }
        });

        if (isCurrent) {
            $body.addClass('is-nav-active');
        }
    }

    function mobileNavToggle() {
        var MenuPadding  = $('.header-logo__wrapper').height();

        if ( $('#main-nav').not("main-nav--active") ){
            $nav.find('.mobile-search').css('margin-top', MenuPadding);

            //Finds which menu item is current and set checkbox to checked
            $nav.find($itemCurrent).has($itemCurrent).children('input').prop('checked', true);
        }

        $('.navbar__toggle').toggleClass("uber-accordion__button-active");
        $('#main-nav').toggleClass("main-nav--active");
        $('html, body').toggleClass("is-blocked");

        $nav.attr('aria-expanded', function (i, attr) {
            return attr == 'true' ? 'false' : 'true'
        });
    }

    function mobileNavClose() {
        if ( $('#main-nav').hasClass("main-nav--active") ){
            $('.navbar__toggle').removeClass("uber-accordion__button-active");
            $('#main-nav').removeClass("main-nav--active");
            $('html, body').removeClass("is-blocked");
            $nav.attr('aria-expanded', 'false');
            $('.navbar__dropdown-input').prop('checked', false);
        };
    }

    // Bind menu load when transitioning media query breakpoints
    window.matchMedia(minMq).addListener(function(mql) {
        // Empty console statement needed to ensure FF always runs this
        console.log('');
        if (mql.matches) {
            mobileNavClose();
            loadMenu();
        }
    });

    if (window.matchMedia(minMq).matches) {
        loadMenu();
        mobileNavClose();
    }
}(jQuery));
